import React from 'react';
import { useTranslation } from 'react-i18next';
import ReactSelect from 'react-select';
import { defaultSelectStyles, selectTheme } from './styles';

const Select = ({
  options,
  className,
  placeholder,
  onChange,
  value,
  label,
  required,
  isDisabled,
  isSearchable,
  // The control's accessible name when it has no visible label (e.g. a filter shown by its placeholder).
  ariaLabel,
  isMulti,
  loading,
  closeMenuOnSelect,
  errorMsg,
  customStyles,
  // The input's id (the label then points at it), and a field error shown elsewhere: aria-invalid and the error's
  // id (react-select keeps aria-describedby for itself).
  inputId,
  ariaInvalid,
  ariaErrorMessage,
  // How an option reads, e.g. a shorter text in the menu than in the chosen value.
  formatOptionLabel,
}) => {
  const [t] = useTranslation();

  const getValue = (isMulti, options, value) => {
    // Grouped options ({label, options: [...]}) are searched inside their groups.
    const flat = options?.flatMap((o) => (Array.isArray(o?.options) ? o.options : [o]));
    if (isMulti) {
      return flat?.filter((o) => value?.includes(o?.value));
    }
    return flat?.find((o) => o?.value === value);
  };

  return (
    <div className={className}>
      {(label || required) && (
        <label htmlFor={inputId} className='mb-1 block text-sm font-medium text-slate-700'>
          {label}
          <span className={`text-error`}>{required && '*'}</span>
        </label>
      )}
      <ReactSelect
        className='relative'
        styles={customStyles ? customStyles : defaultSelectStyles}
        options={options}
        isSearchable={isSearchable}
        placeholder={placeholder ?? t('buttons.select')}
        aria-label={ariaLabel || label || undefined}
        noOptionsMessage={() => t('table.no_options')}
        loadingMessage={() => t('table.loading')}
        onChange={onChange}
        value={getValue(isMulti, options, value) || ''}
        isDisabled={isDisabled}
        isMulti={isMulti}
        isLoading={loading}
        closeMenuOnSelect={closeMenuOnSelect}
        theme={selectTheme}
        inputId={inputId}
        aria-invalid={ariaInvalid || undefined}
        aria-errormessage={ariaErrorMessage}
        formatOptionLabel={formatOptionLabel}
      />
      {errorMsg && (
        <span className='mt-1 text-xs font-semibold text-error'>
          {errorMsg}
        </span>
      )}
    </div>
  );
};

export default Select;
